import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { testimonials } from '../mock/data';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const Testimonials = () => {
  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#FAF8F3]">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-12">
          <Badge className="mb-4 bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/20">Testimonials</Badge>
          <h2 className="text-4xl md:text-5xl font-serif text-[#0A1628] mb-4">
            Stories of <span className="italic text-[#D4AF37]">Impact</span>
          </h2>
          <p className="text-gray-600">Hear from the people whose lives have been touched by EWRF programmes.</p>
        </div>

        <div className="relative">
          <Card className="border-[#D4AF37]/20 shadow-lg">
            <CardContent className="p-8 md:p-12">
              <div className="mb-6">
                <p className="text-lg text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonials[current].content}"
                </p>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#C19A2E] flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-xl">{testimonials[current].initial}</span>
                </div>
                <div>
                  <h5 className="font-semibold text-[#0A1628]">{testimonials[current].name}</h5>
                  <p className="text-sm text-gray-500">{testimonials[current].role}</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="flex items-center justify-center gap-4 mt-8">
            <Button
              onClick={prev}
              variant="outline"
              size="icon"
              className="rounded-full border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transition-all"
            >
              <ChevronLeft className="w-5 h-5" />
            </Button>
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrent(index)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    index === current ? 'bg-[#D4AF37] w-8' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
            <Button
              onClick={next}
              variant="outline"
              size="icon"
              className="rounded-full border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transition-all"
            >
              <ChevronRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;